module.exports = __webpack_public_path__ + "images/TrelloGoldBadge.3165e93a7df78639d858.png";